"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.search.placeholder': 'Cerca passi...',
};
